document.addEventListener('DOMContentLoaded', () => {

    const cover = document.getElementById('cover');
    
    document.documentElement.classList.add('is-loaded');

    setTimeout(() => {
        inviewInit();
        window.anims();
        window.carousels();
        cover.remove();        
    }, 250);  
    
    //window.addEventListener('load', init);

}, false);
